import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import Constants from '../../services/Constants.json';

const RecaptchaComponent = ({ onChangeCaptcha }) => {
    return (
        <div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <ReCAPTCHA
                    // sitekey={Constants.SiteKey}
                    sitekey="6Lf_944oAAAAAJYchyqv-TJaDMmA1dcPwyQeVMXx"
                    onChange={onChangeCaptcha}
                />
            </div>
        </div>
    )
}

export default RecaptchaComponent
